import { Loader2 } from "lucide-react";

export const SmoothLoadingWrapper = (({ children, loading, message }: { children: React.ReactNode; loading: boolean; message?: string }) => {

    return <>
        <div className={`absolute w-full h-full grid place-items-center bg-white ${loading ? "opacity-100" : "opacity-0"} transition-opacity`}>
            <div className="flex gap-1">
                <Loader2 className='w-6 h-6 animate-spin' />
                <span>{message || "Đang tải dữ liệu..."}</span>
            </div>
        </div>
        <div className={`transition-opacity ${loading ? "opacity-0" : "opacity-100"}`}>
            {children}
        </div>
    </>
})